import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { MasterConsultaGruposService } from '../../master-consulta-grupos.service';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';

@Component({
  selector: 'app-master-mensagem-deletar',
  templateUrl: './master-mensagem-deletar.component.html',
  styleUrls: ['./master-mensagem-deletar.component.scss']
})
export class MasterMensagemDeletarComponent implements OnInit {

  group;

  constructor(
    public dialogRef: MatDialogRef<MasterMensagemDeletarComponent>,
    private masterConsultaGroupService: MasterConsultaGruposService,
    private msalService: MsalService,
    private shared:SharedVariable
  ) {

  }

  ngOnInit() { }

  deleteGroup() {
    this.masterConsultaGroupService.deleteGroup(this.group.id)
      .subscribe(data => {
        this.dialogRef.close(true);
        this.groupDeletionLog()
      });
  }

  groupDeletionLog() {
    const userName = this.shared.mailUser;

    const log = {
      userName: userName,
      data: new Date(),
    }
    this.masterConsultaGroupService.groupDeletionLog(log);
  }

}
